const o = (n) => typeof n == "function";
function c(n, ...t) {
  return o(n) ? n(...t) : n;
}
export {
  o as isFunction,
  c as runIfFn
};
